import PropTypes from "prop-types";
import React from "react";
import Tooltip from "react-tooltip-lite";
import classnames from "classnames";
import style from "./hint-bubble.css";

function HintBubble(props) {
    let className = classnames(style.hintBubbleWrapper, props.className);
    let content = <div className={style.hintBubbleTooltipWrapper}>{props.tooltipText}</div>;
    return (
        <Tooltip
            background="#333"
            className={className}
            content={content}
            direction="down"
            padding="0"
            tipContentHover={true}
        >
            <span className={style.hintBubble} />
        </Tooltip>
    );
}

export default HintBubble;

HintBubble.propTypes = {
    className: PropTypes.string,
    tooltipText: PropTypes.node.isRequired,
};
